// Sends GA4 events through the gtag snippet injected by rollup.config.js.
// Never throws: analytics must not break the page when GA is blocked.
export function track(eventName, params = {}) {
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params)
    }
  } catch (e) {
    // ignore
  }
}

// Builds the shared params for a subscription plan. Prices are stored in cents.
export function planParams(product, durationType) {
  return {
    plan_name: product.title,
    billing_period: durationType === 'year' ? 'yearly' : 'monthly',
    currency: 'USD',
    value: Number(product.price) / 100,
  }
}
